import { useEffect, useRef, useState } from 'react';
import void_ava from 'assets/void_ava.jpg';
import styled from 'styled-components';

interface VideoAvatarProps {
  videoUrl: string | undefined;
  imageUrl: string;
  onClick?: () => void;
  isShowVideoAvatar?: boolean;
}

export const VideoAvatar: React.FC<VideoAvatarProps> = ({
  videoUrl,
  imageUrl,
  onClick,
  isShowVideoAvatar
}) => {
  const [showVideo, setShowVideo] = useState<boolean>(isShowVideoAvatar || false);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (isShowVideoAvatar && videoRef.current && showVideo) {
      const playVideo = async () => {
        try {
          await videoRef.current?.play();
        } catch (error) {
          console.error('Error playing video:', error);
          setShowVideo(false);
        }
      };
      playVideo();
    }
  }, [isShowVideoAvatar]);

  if (!showVideo || !videoUrl) {
    return <CharacterAvatar className="cursor-pointer" src={imageUrl} onClick={onClick} />;
  }

  return (
    <VideoWrapper>
      <RoundVideo
        ref={videoRef}
        muted
        playsInline
        preload="auto"
        onEnded={() => setShowVideo(false)}
      >
        <source src={videoUrl} type="video/mp4" />
      </RoundVideo>
    </VideoWrapper>
  );
};

const VideoWrapper = styled.div`
  width: 54px;
  height: 54px;
  position: relative;
  border-radius: 1000px;
  overflow: hidden;
`;

const RoundVideo = styled.video<
  React.VideoHTMLAttributes<HTMLVideoElement> & { ref?: React.RefObject<HTMLVideoElement> }
>`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const CharacterAvatar = styled.div<{
  src: string;
  className?: string;
  onClick?: () => void;
}>`
  width: 54px;
  height: 54px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 1000px;
  background-image: url('${props => props.src || void_ava}');
`;
